
/* pp-flashy-close-fix.js
   Enlarges Flashy popup's X close button from 17×17 to 44×44 px,
   adds a soft background circle, and gives the SVG proper viewBox
   so it scales cleanly. Runs once flashy-popup is mounted. */
(function () {
  var STYLE = [
    '.fls-close-popup a.fls-close.fls-top-right {',
    '  width: 44px !important;',
    '  height: 44px !important;',
    '  padding: 10px !important;',
    '  box-sizing: border-box !important;',
    '  background: rgba(255,255,255,0.92) !important;',
    '  border-radius: 50% !important;',
    '  box-shadow: 0 2px 10px rgba(0,0,0,0.18) !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  z-index: 100000 !important;',
    '  transition: transform .15s ease, box-shadow .15s ease !important;',
    '  cursor: pointer !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right:hover {',
    '  transform: scale(1.08) !important;',
    '  box-shadow: 0 3px 14px rgba(0,0,0,0.28) !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right svg {',
    '  width: 22px !important;',
    '  height: 22px !important;',
    '  display: block !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right svg line {',
    '  stroke: #511e16 !important;',
    '  stroke-width: 2.2 !important;',
    '  stroke-linecap: round !important;',
    '}',
    /* Make sure container has enough room so the enlarged button isn’t clipped */
    '.fls-close-popup {',
    '  overflow: visible !important;',
    '  min-height: 48px !important;',
    '}'
  ].join('\n');

  function patch(fp) {
    if (!fp || !fp.shadowRoot || fp.__ppCloseFixed) return;
    fp.__ppCloseFixed = true;

    // Inject style tag into shadow root
    var s = document.createElement('style');
    s.setAttribute('data-pp', 'close-fix');
    s.textContent = STYLE;
    fp.shadowRoot.appendChild(s);

    // Fix the SVG so scaling works (original has no viewBox → line coords 1..15)
    function fixSvg() {
      var svgs = fp.shadowRoot.querySelectorAll('a.fls-close svg');
      svgs.forEach(function (svg) {
        if (!svg.getAttribute('viewBox')) svg.setAttribute('viewBox', '0 0 16 16');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      });
    }
    fixSvg();

    // Flashy may re-render — watch for it
    var mo = new MutationObserver(fixSvg);
    mo.observe(fp.shadowRoot, { childList: true, subtree: true });
  }

  // Poll until flashy-popup exists (Flashy loads async)
  var tries = 0;
  var iv = setInterval(function () {
    var fp = document.querySelector('flashy-popup');
    if (fp) { patch(fp); clearInterval(iv); return; }
    if (++tries > 60) clearInterval(iv);  // give up after ~30s
  }, 500);

  // Also observe body for late injection
  var bodyMo = new MutationObserver(function () {
    var fp = document.querySelector('flashy-popup');
    if (fp) patch(fp);
  });
  if (document.body) bodyMo.observe(document.body, { childList: true, subtree: false });
})();
